<template>
  <div>
    <seg-main
      width="1236px"
    >
      <el-container>
        <el-header style="display: flex; align-items: center; justify-content: flex-end;">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="fromPage">
                搜索
              </el-breadcrumb-item>
              <el-breadcrumb-item>{{ article.content.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-header>
        <el-main>
          <div
            class="main-content"
            v-html="article.content.content"
          />
        </el-main>
      </el-container>
    </seg-main>
  </div>
</template>

<script>
import SegMain from '@/components/segPart/segMain';
import {getArticle} from '@/api';
import {menu} from '@/constant';
export default {
  name: 'Detail',
  components: {SegMain},
  props: {
    articleId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      article: {
        content: {}
      },
      contentLoading: false,
      fromPage: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.fromPage = from
    })
  },
  computed: {
    menu: function () {
      return menu[5].children
    }
  },
  watch: {
    articleId: {
      handler: function () {
        this.getContent()
      },
      immediate: true
    }
  },
  methods: {
    getContent() {
      this.contentLoading = true
      getArticle({
        id: this.articleId
      }).then(res => {
        if(res.data.success) {
          this.article = res.data.data[0]
          this.article.content = JSON.parse(this.article.content)
        }
        this.contentLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
  .main-content {
    position: relative;
    ::v-deep {
      img {
        max-width: 100%!important;
      }
    }
  }
</style>
